/*  MUI  */
import { Typography } from '@mui/material';

/*  Shared  */
import { TooltipQ } from 'application/Shared/Components/Tooltips';
import { FontSizes } from 'application/Shared/Constants';

/* React */
import React from 'react';

/**
 * PageTitle component displays a page title with an optional tooltip.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.title - The text to be displayed as the page title.
 * @param {string} [props.tooltipText] - Optional text for the tooltip. If provided, a tooltip will be displayed next to the title.
 * @returns {React.ReactElement} A Typography component containing the title and optional tooltip.
 *
 * @example
 * <PageTitle title="Dashboard" tooltipText="This is the main dashboard page" />
 */
export const PageTitle = ({
    title,
    tooltipText
}: {
    /**
     * The text to be displayed as the page title.
     */
    title: string;
    /**
     * Optional text for the tooltip. If provided, a tooltip will be displayed next to the title.
     */
    tooltipText?: string;
}): React.ReactElement => (
    <Typography
        data-testid="pageTitle"
        sx={{
            alignItems: 'center',
            display: 'inline-flex',
            marginBottom: '24px'
        }}
        variant="h3"
    >
        {title}
        {tooltipText && <TooltipQ text={tooltipText} size={FontSizes[3]} />}
    </Typography>
);
